let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3tE3J")).then(() => parcelRequire('c9E3E'));